import { render, staticRenderFns } from "./OEmbed.vue?vue&type=template&id=1d7b0cce&"
import script from "./OEmbed.vue?vue&type=script&lang=js&"
export * from "./OEmbed.vue?vue&type=script&lang=js&"
import style0 from "./OEmbed.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports